import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/apps/web/app/_components/session-provider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackgroundActionContextProvider"] */ "/app/apps/web/app/_contexts/background-action-context/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/web/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
